import { FilterKey } from '@studyportals/search-filters';
export class SearchVolumeAreasDisciplineRule {
    areaFilterKey = FilterKey.AREA;
    areaIdsWithSearchVolume = [
        3578, 3579, 3580, 3581, 3582, 3583, 3584, 3585, 3586, 3587, 3588, 3589, 3590, 3591, 3592, 3593, 3594, 3595, 3596, 3597, 3598, 3599,
        3600, 3601, 3602, 3603, 3604, 3605, 3606, 3607, 3608, 3609, 3610, 3611, 3612, 3613, 3614, 3615, 3616, 3617, 3618, 3619, 3620, 3621,
        3622, 3623, 3624, 3625, 3626, 3627, 3628
    ];
    getName() {
        return 'SearchVolumeAreasDisciplineRule';
    }
    forSearch(dependencies) {
        const value = dependencies.seoInfoBase.getFilterOptionValueBy(this.areaFilterKey, dependencies.filterState);
        if (!value) {
            return Promise.resolve(false);
        }
        return Promise.resolve(this.hasSearchVolume(value));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forSitemapGenerator(filterKeyValues) {
        throw new Error('Method not implemented.');
    }
    hasSearchVolume(value) {
        return this.areaIdsWithSearchVolume.includes(parseInt(value));
    }
}
